import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import router from './router/router.js'
import store from './store/index.js'
import firebase from 'Firebase'
import VueCharts from 'vue-chartjs'
// import Chart from 'chart.js'


firebase.auth().onAuthStateChanged(function (user) {
  if (user) {
    store.dispatch('verifyLogin', user.uid).then((u) => {
      store.commit('SET_USER', u);
      router.push("/Schedules")
      store.dispatch('initializeDatabase', u)
      store.dispatch('setLogged', true);
    })
      .catch((error) => {
        store.commit('RESET_DATABASE')
        store.commit('RESET_USER');
        store.commit('SET_ERROR', error)
        firebase.auth().signOut().then(function () {
          /* console.log("Log out successful") */
        }).catch(function (error) {
          // An error happened.
        });
        console.log(error)
      })
  } else {
    router.push("/Login")
    store.dispatch('setLogged', false);
    // Clear store
    store.commit('RESET_USER');
    store.commit('RESET_DATABASE')
    store.commit('RESET_BRANDS')
    store.commit('RESET_CATEGORIES')
    store.commit('RESET_DEVICES')
    store.commit('RESET_SCHEDULES')
    store.commit('RESET_STATS')
    store.commit('RESET_VIDEOS')


  }
});

Vue.use(Vuetify)


//store.dispatch("loadTagImages");
//store.dispatch("loadBrandImages");

new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js